import React from 'react';
import { Autocomplete, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import moment from 'moment';
import SampleNameAndBadge from './SampleNameAndBadge';

export default function DNASelector({options, label, concentrationUnit, error, helperText, color, ...props}) {
  const formatInfo = (text, final = false) => (
    <>
      <Typography
        sx={{ display: 'inline' }}
        component="span"
        variant="body2"
        color="text.primary"
      >
        {text}
      </Typography>
      {!final && " • "}
    </>
  )
  return (
    <Autocomplete
      autoHighlight
      autoSelect
      openOnFocus
      fullWidth
      options={options || []}
      loading={options === undefined}
      getOptionLabel={option => option?.name || ""}
      renderOption={(props, option) => (
        <ListItem dense {...props} key={option.id}>
          <ListItemText
            primary={
              <SampleNameAndBadge sample={{...option, display_name: option.name + (option.colony_id ? "-" + option.colony_id : "")}} />
            }
            secondary={
              <>
                {option.date && formatInfo(moment(option.date).format("M/D/YY"), !option.concentration && !option.description)}
                {option.concentration && formatInfo((option.concentration / 1000).toFixed(0) + (concentrationUnit || ""), !option.description)}
                {option.description || ""}
              </>
            }
            secondaryTypographyProps={{style: {whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}}
          />
        </ListItem>
      )}
      isOptionEqualToValue={(option, value) => (option.id && value.id && (option.id === value.id)) || (option === value)} // direclty compare unless id is present
      renderInput={params => (
        <TextField
          {...params}
          margin="dense"
          label={label}
          variant="standard"
          error={error}
          helperText={helperText}
          color={color}
        />
      )}
      ChipProps={{size: "small", variant: "outlined"}}
      {...props}
    />
  )
}
